// TODO:
/**
 * Will use this component in "Create Transaction" for User on trial
 */

import { ImgHTMLAttributes } from "react";
import { useTranslation } from "react-i18next";

import Button from "src/components-v2/Button";
import Modal from "src/components-v2/Modal";

export type OnTrialModalProps = {
  /**
   * Show or hide modal
   */
  show: boolean;

  /**
   * Modal toggle
   */
  toggle: Function;

  /**
   * Title for the modal
   */
  title: string;

  /**
   * Total remaining of the trial
   */
  remains: string;

  /**
   * Remaining of the trial
   */
  remainsLeft: string;

  /**
   * Description of trial
   */
  description: string;

  /**
   *
   */
  ilustration: ImgHTMLAttributes<HTMLImageElement>["src"];
};

function OnTrialModal(props: OnTrialModalProps) {
  const { show, toggle, title, remains, remainsLeft, description, ilustration } = props;
  const { t } = useTranslation("verification");

  return (
    <Modal
      data-qaid="qa-modal-terms-and-conditions"
      withoutHeader
      show={show}
      onClose={() => toggle(false)}
      closeOnOverlay
      withoutCloseButton
    >
      <div className="u-text-center">
        <img alt="ontrial-modal" src={ilustration} width="185" className="u-mb-7" />
        <div className="u-text-large u-font-bold u-py-4">{title}</div>
        <p className="u-m-0">
          {remains}
          <span className="u-font-bold">{remainsLeft}</span>.
        </p>
        <p className="u-pb-2">{description}</p>
      </div>
      <Button variant="secondary" onClick={() => toggle(false)} block>
        {t("ontrial-modal.understand")}
      </Button>
    </Modal>
  );
}

export default OnTrialModal;
